
import { IOArray__get_U32Contents, IOArray__get_BigContents, FastSimulation__FastComponentOf_6546966D, FastSimulation__ComponentAt_3B11D6BA, FData, FastSimulation__ComponentOf_6546966D } from "../SimTypes.js";
import { forAll, ofArray, map, isEmpty, iterate, empty } from "../../fable_modules/fable-library-js.5.13.0/List.js";
import { printf, toFail } from "../../fable_modules/fable-library-js.5.13.0/String.js";
import { equals, toUInt32, fromUInt32 } from "../../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { map as map_1, getSubArray, setItem, fill, tryItem, collect, item } from "../../fable_modules/fable-library-js.5.13.0/Array.js";
import { runCombinationalLogicFData, runCombinationalLogic } from "./FastRun.js";
import { evalExp, FSInterface, SimulationComponentState, FastData, FastBits } from "../SimGraphTypes.js";
import { fixedOf } from "../RamStore.js";
import { tryFind } from "../../fable_modules/fable-library-js.5.13.0/Map.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.5.13.0/Result.js";
import { memoizeByIdentity } from "../../Common/Helpers.js";
import { loadedComponentIsSameAsProject } from "../CanvasExtractor.js";
import { twosComp } from "../NumberHelpers.js";

function setSimulationInput(cid, fd, step, fs) {
    const matchValue = FastSimulation__ComponentOf_6546966D(fs, [cid, empty()]);
    const matchValue_1 = fd.Width | 0;
    if (matchValue == null) {
        toFail(printf("Can\'t find %A in FastSim"))(cid);
    }
    else if (matchValue_1 > 32) {
        const fc_1 = matchValue;
        const step_1 = (step % fs.MaxArraySize) | 0;
        let dat;
        const matchValue_3 = fd.Dat;
        dat = ((matchValue_3.tag === 1) ? matchValue_3.fields[0] : fromUInt32(matchValue_3.fields[0]));
        const this$ = item(0, fc_1.Outputs);
        this$.BigIntSlab[(this$.StepBase + step_1)] = dat;
    }
    else {
        const fc_2 = matchValue;
        const step_3 = (step % fs.MaxArraySize) | 0;
        let dat_2;
        const this$_3 = fd;
        const matchValue_4 = this$_3.Dat;
        dat_2 = ((matchValue_4.tag === 1) ? ((this$_3.Width <= 32) ? (toUInt32(matchValue_4.fields[0]) >>> 0) : toFail(printf("GetQint32 Can\'t turn Alg into a uint32"))) : matchValue_4.fields[0]);
        const this$_2 = item(0, fc_2.Outputs);
        this$_2.UInt32Slab[(this$_2.StepBase + step_3)] = dat_2;
    }
}

function setSimulationInputFData(cid, fd, step, fs) {
    const matchValue = FastSimulation__ComponentOf_6546966D(fs, [cid, empty()]);
    if (matchValue == null) {
        toFail(printf("Can\'t find %A in FastSim"))(cid);
    }
    else {
        const fc = matchValue;
        item(0, fc.Outputs).FDataStep[step % fs.MaxArraySize] = fd;
    }
}

/**
 * Change an input and make simulation correct. N.B. step must be the latest
 * time-step since future steps are not rerun (TODO: perhaps they should be!)
 */
export function changeInput(cid, input, step, fastSim) {
    setSimulationInput(cid, (input.tag === 1) ? toFail(printf("Algebraic inputs not supported.")) : input.fields[0], step, fastSim);
    runCombinationalLogic(step, fastSim);
}

export function changeInputFData(cid, input, step, fastSim) {
    setSimulationInputFData(cid, (input.tag === 1) ? (new FData(/* Alg */ 1, [input.fields[0]])) : (new FData(/* Data */ 0, [input.fields[0]])), step, fastSim);
    runCombinationalLogicFData(step, fastSim);
}

/**
 * Change multiple inputs in one batch before re-running the simulation
 * NOTE - Only used in TruthTable
 */
export function changeInputBatch(step, fastSim, changes) {
    iterate((tupledArg) => {
        const input = tupledArg[1];
        setSimulationInputFData(tupledArg[0], (input.tag === 1) ? (new FData(/* Alg */ 1, [input.fields[0]])) : (new FData(/* Data */ 0, [input.fields[0]])), step, fastSim);
    }, changes);
    runCombinationalLogicFData(step, fastSim);
}

export function extractStatefulComponents(step, fastSim) {
    return collect((fc) => {
        let this$, step_1, this$_1, step_2, this$_2, step_3;
        if (isEmpty(fc.AccessPath)) {
            const matchValue_1 = fc.FType;
            let matchResult, w_6;
            switch (matchValue_1.tag) {
                case 33: {
                    if (matchValue_1.fields[0] > 32) {
                        matchResult = 0;
                        w_6 = matchValue_1.fields[0];
                    }
                    else {
                        matchResult = 1;
                    }
                    break;
                }
                case 34: {
                    if (matchValue_1.fields[0] > 32) {
                        matchResult = 0;
                        w_6 = matchValue_1.fields[0];
                    }
                    else {
                        matchResult = 1;
                    }
                    break;
                }
                case 35: {
                    if (matchValue_1.fields[0] > 32) {
                        matchResult = 0;
                        w_6 = matchValue_1.fields[0];
                    }
                    else {
                        matchResult = 1;
                    }
                    break;
                }
                case 37: {
                    if (matchValue_1.fields[0] > 32) {
                        matchResult = 0;
                        w_6 = matchValue_1.fields[0];
                    }
                    else {
                        matchResult = 1;
                    }
                    break;
                }
                case 36: {
                    if (matchValue_1.fields[0] > 32) {
                        matchResult = 0;
                        w_6 = matchValue_1.fields[0];
                    }
                    else {
                        matchResult = 1;
                    }
                    break;
                }
                case 38: {
                    if (matchValue_1.fields[0] > 32) {
                        matchResult = 0;
                        w_6 = matchValue_1.fields[0];
                    }
                    else {
                        matchResult = 1;
                    }
                    break;
                }
                default:
                    matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return [[fc, new SimulationComponentState(/* RegisterState */ 2, [new FastData(new FastBits(/* BigWord */ 1, [(this$ = item(0, fc.Outputs), (step_1 = ((step % fastSim.MaxArraySize) | 0), this$.BigIntSlab[(this$.StepBase + step_1)]))]), w_6)])]];
                default: {
                    let matchResult_1, w_7;
                    switch (matchValue_1.tag) {
                        case 31:
                        case 32: {
                            matchResult_1 = 0;
                            break;
                        }
                        case 40: {
                            matchResult_1 = 2;
                            break;
                        }
                        case 41:
                        case 42: {
                            matchResult_1 = 3;
                            break;
                        }
                        case 33: {
                            matchResult_1 = 1;
                            w_7 = matchValue_1.fields[0];
                            break;
                        }
                        case 34: {
                            matchResult_1 = 1;
                            w_7 = matchValue_1.fields[0];
                            break;
                        }
                        case 35: {
                            matchResult_1 = 1;
                            w_7 = matchValue_1.fields[0];
                            break;
                        }
                        case 37: {
                            matchResult_1 = 1;
                            w_7 = matchValue_1.fields[0];
                            break;
                        }
                        case 36: {
                            matchResult_1 = 1;
                            w_7 = matchValue_1.fields[0];
                            break;
                        }
                        case 38: {
                            matchResult_1 = 1;
                            w_7 = matchValue_1.fields[0];
                            break;
                        }
                        default:
                            matchResult_1 = 4;
                    }
                    switch (matchResult_1) {
                        case 0:
                            return [[fc, new SimulationComponentState(/* RegisterState */ 2, [new FastData(new FastBits(/* Word */ 0, [(this$_1 = item(0, fc.Outputs), (step_2 = ((step % fastSim.MaxArraySize) | 0), this$_1.UInt32Slab[(this$_1.StepBase + step_2)]))]), 1)])]];
                        case 1:
                            return [[fc, new SimulationComponentState(/* RegisterState */ 2, [new FastData(new FastBits(/* Word */ 0, [(this$_2 = item(0, fc.Outputs), (step_3 = ((step % fastSim.MaxArraySize) | 0), this$_2.UInt32Slab[(this$_2.StepBase + step_3)]))]), w_7)])]];
                        case 2:
                            return [[fc, new SimulationComponentState(/* RamState */ 3, [fixedOf(matchValue_1.fields[0])])]];
                        case 3: {
                            let matchValue_2;
                            const option_1 = fc.State;
                            matchValue_2 = ((option_1 != null) ? item(step % fastSim.MaxArraySize, option_1.Step) : undefined);
                            if (matchValue_2 != null) {
                                return [[fc, matchValue_2]];
                            }
                            else {
                                return toFail(printf("Missing RAM state for step %d of %s"))(step)(fc.FullName);
                            }
                        }
                        default:
                            return toFail(printf("Unsupported state extraction from clocked component type %s %A"))(fc.FullName)(fc.FType);
                    }
                }
            }
        }
        else {
            return [];
        }
    }, fastSim.FClockedComps);
}

/**
 * The step array an output port's data lives in, resolved ONCE.
 * 
 * Everything `extractFastSimulationOutput` does per read except the read itself: the map lookup
 * on (component, access path) - a structural comparison on a list - and the hop through
 * FCustomOutputCompLookup that answers a custom component's output with the array of the Output
 * component inside the subsheet. What comes back is the array and its width, from which a value
 * at a cycle is an indexed load.
 * 
 * For anything reading MANY samples of the same signal. Reading a whole window per sample cost
 * that lookup, a FastData and an FSInterface allocation, and a conversion to bigint, per sample -
 * for a wave that is often one bit wide.
 * 
 * A Result, not an exception: the caller may be a server answering a request it did not compose,
 * where a bad signal name is an answer rather than a crash.
 */
export function tryFindOutputArray(fs_mut, _arg1__mut, _arg1__1_mut, opn_mut) {
    tryFindOutputArray:
    while (true) {
        const fs = fs_mut, _arg1_ = _arg1__mut, _arg1__1 = _arg1__1_mut, opn = opn_mut;
        const _arg = [_arg1_, _arg1__1];
        const cid = _arg[0];
        const ap = _arg[1];
        const n = opn;
        const matchValue = FastSimulation__ComponentOf_6546966D(fs, [cid, ap]);
        if (matchValue == null) {
            const matchValue_2 = tryFind([[cid, ap], opn], fs.FCustomOutputCompLookup);
            if (matchValue_2 == null) {
                return new FSharpResult$2(/* Error */ 1, [`no component ${cid} at ${ap} in this simulation`]);
            }
            else {
                const tupledArg = FastSimulation__ComponentAt_3B11D6BA(fs, matchValue_2).fId;
                fs_mut = fs;
                _arg1__mut = tupledArg[0];
                _arg1__1_mut = tupledArg[1];
                opn_mut = 0;
                continue tryFindOutputArray;
            }
        }
        else {
            const fc = matchValue;
            const matchValue_1 = tryItem(n, fc.Outputs);
            if (matchValue_1 != null) {
                if (matchValue_1.Width === 0) {
                    const io_1 = matchValue_1;
                    return new FSharpResult$2(/* Error */ 1, [`output ${n} of ${fc.FullName} carries no data`]);
                }
                else {
                    const io_2 = matchValue_1;
                    return new FSharpResult$2(/* Ok */ 0, [io_2]);
                }
            }
            else {
                return new FSharpResult$2(/* Error */ 1, [`${fc.FullName} has no output port ${n}`]);
            }
        }
        break;
    }
}

export const driverArraysOf = memoizeByIdentity((fs) => {
    const arrays = fill(new Array(fs.NumStepArrays), 0, fs.NumStepArrays, undefined);
    const add = (io) => {
        if ((io.Index >= 0) && (io.Index < arrays.length)) {
            setItem(arrays, io.Index, io);
        }
    };
    fs.FCompsByIndex.forEach((fc) => {
        fc.Outputs.forEach(add);
        fc.InputLinks.forEach(add);
    });
    return arrays;
});

/**
 * One sample of a resolved array, as a bigint whatever the width.
 * 
 * The modulo is not optional. A step array is a REGION of a shared slab, so a step past the end
 * of the region reads the next port's data with nothing to catch it - see IOArray.
 */
export function sampleOfArray(fs, io, cycle) {
    const step = (cycle % fs.MaxArraySize) | 0;
    if (io.Width > 32) {
        const this$ = io;
        const step_1 = step | 0;
        if ((this$.BigIntSlab.length === 0) ? true : ((step_1 >>> 0) >= (this$.StepLength >>> 0))) {
            return undefined;
        }
        else {
            return this$.BigIntSlab[(this$.StepBase + step_1)];
        }
    }
    else {
        let option_1;
        const this$_1 = io;
        const step_2 = step | 0;
        option_1 = (((this$_1.UInt32Slab.length === 0) ? true : ((step_2 >>> 0) >= (this$_1.StepLength >>> 0))) ? undefined : (this$_1.UInt32Slab[(this$_1.StepBase + step_2)]));
        if (option_1 != null) {
            return fromUInt32(option_1);
        }
        else {
            return undefined;
        }
    }
}

/**
 * return output port data from simulation as a Bit list
 * Each element in list is one bit
 */
export function extractFastSimulationOutput(fs_mut, step_mut, _arg1__mut, _arg1__1_mut, opn_mut) {
    extractFastSimulationOutput:
    while (true) {
        const fs = fs_mut, step = step_mut, _arg1_ = _arg1__mut, _arg1__1 = _arg1__1_mut, opn = opn_mut;
        const _arg = [_arg1_, _arg1__1];
        const cid = _arg[0];
        const ap = _arg[1];
        const n = opn;
        const matchValue = FastSimulation__ComponentOf_6546966D(fs, [cid, ap]);
        if (matchValue == null) {
            const matchValue_4 = tryFind([[cid, ap], opn], fs.FCustomOutputCompLookup);
            if (matchValue_4 == null) {
                return toFail(printf("What? extracting component data failed - can\'t find component from id"));
            }
            else {
                const tupledArg = FastSimulation__ComponentAt_3B11D6BA(fs, matchValue_4).fId;
                fs_mut = fs;
                step_mut = step;
                _arg1__mut = tupledArg[0];
                _arg1__1_mut = tupledArg[1];
                opn_mut = 0;
                continue extractFastSimulationOutput;
            }
        }
        else {
            const fc = matchValue;
            const matchValue_1 = item(n, fc.Outputs).Width | 0;
            if (matchValue_1 === 0) {
                return toFail(`Can't find valid data in step ${step}:index${step % fs.MaxArraySize} from ${fc.FullName} with clockTick=${fs.ClockTick}`);
            }
            else if (matchValue_1 > 32) {
                let matchValue_2;
                const this$_1 = item(n, fc.Outputs);
                const step_1 = (step % fs.MaxArraySize) | 0;
                matchValue_2 = (((this$_1.BigIntSlab.length === 0) ? true : ((step_1 >>> 0) >= (this$_1.StepLength >>> 0))) ? undefined : (this$_1.BigIntSlab[(this$_1.StepBase + step_1)]));
                if (matchValue_2 != null) {
                    return new FSInterface(/* IData */ 0, [new FastData(new FastBits(/* BigWord */ 1, [matchValue_2]), matchValue_1)]);
                }
                else {
                    return toFail(`What? extracting output ${n}- in step ${step} from ${fc.FullName} failed with clockTick=${fs.ClockTick}`);
                }
            }
            else {
                let matchValue_3;
                const this$_2 = item(n, fc.Outputs);
                const step_2 = (step % fs.MaxArraySize) | 0;
                matchValue_3 = (((this$_2.UInt32Slab.length === 0) ? true : ((step_2 >>> 0) >= (this$_2.StepLength >>> 0))) ? undefined : (this$_2.UInt32Slab[(this$_2.StepBase + step_2)]));
                if (matchValue_3 != null) {
                    return new FSInterface(/* IData */ 0, [new FastData(new FastBits(/* Word */ 0, [matchValue_3]), matchValue_1)]);
                }
                else {
                    return toFail(`What? extracting output ${n}- in step ${step} from ${fc.FullName} failed with clockTick=${fs.ClockTick}`);
                }
            }
        }
        break;
    }
}

export function extractFastSimulationOutputFData(fs_mut, step_mut, _arg1__mut, _arg1__1_mut, opn_mut) {
    extractFastSimulationOutputFData:
    while (true) {
        const fs = fs_mut, step = step_mut, _arg1_ = _arg1__mut, _arg1__1 = _arg1__1_mut, opn = opn_mut;
        const _arg = [_arg1_, _arg1__1];
        const cid = _arg[0];
        const ap = _arg[1];
        const n = opn;
        const matchValue = FastSimulation__ComponentOf_6546966D(fs, [cid, ap]);
        if (matchValue == null) {
            const matchValue_2 = tryFind([[cid, ap], opn], fs.FCustomOutputCompLookup);
            if (matchValue_2 == null) {
                return toFail(printf("What? extracting component data failed - can\'t find component from id"));
            }
            else {
                const tupledArg = FastSimulation__ComponentAt_3B11D6BA(fs, matchValue_2).fId;
                fs_mut = fs;
                step_mut = step;
                _arg1__mut = tupledArg[0];
                _arg1__1_mut = tupledArg[1];
                opn_mut = 0;
                continue extractFastSimulationOutputFData;
            }
        }
        else {
            const fc = matchValue;
            const matchValue_1 = tryItem(step % fs.MaxArraySize, item(n, fc.Outputs).FDataStep);
            if (matchValue_1 != null) {
                if (matchValue_1.tag === 1) {
                    const exp = matchValue_1.fields[0];
                    return new FSInterface(/* IAlg */ 1, [evalExp(exp)]);
                }
                else {
                    const d = matchValue_1.fields[0];
                    if (d.Width === 0) {
                        return toFail(`Can't find valid data in step ${step}:index${step % fs.MaxArraySize} from ${fc.FullName} with clockTick=${fs.ClockTick}`);
                    }
                    else {
                        return new FSInterface(/* IData */ 0, [d]);
                    }
                }
            }
            else {
                return toFail(`What? extracting output ${n} in step ${step} from ${fc.FullName} failed with clockTick=${fs.ClockTick}`);
            }
        }
        break;
    }
}

/**
 * return state data from simulation
 */
export function extractFastSimulationState(fs, step, _arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const cid = _arg[0];
    const ap = _arg[1];
    const matchValue = FastSimulation__ComponentOf_6546966D(fs, [cid, ap]);
    if (matchValue == null) {
        return toFail(`What? Can't find fast component ${[cid, ap]}`);
    }
    else {
        const fc = matchValue;
        const matchValue_1 = fc.State;
        if (matchValue_1 != null) {
            const matchValue_3 = tryItem(step % fs.MaxArraySize, matchValue_1.Step);
            if (matchValue_3 == null) {
                return toFail(`What? Can't extract state in step ${step} from ${fc.FullName}`);
            }
            else {
                return matchValue_3;
            }
        }
        else {
            const matchValue_2 = fc.SimComponent.Type;
            if (matchValue_2.tag === 39) {
                return new SimulationComponentState(/* RamState */ 3, [fixedOf(matchValue_2.fields[0])]);
            }
            else {
                return toFail(printf("What? extracting State in step %d from %s failed"))(step)(fc.FullName);
            }
        }
    }
}

/**
 * Extract top-level inputs or outputs with names and wire widths. Used by legacy code.
 */
export function extractFastSimulationIOs(simIOs, simulationData) {
    return map((io) => {
        const io_1 = io;
        return [io_1, extractFastSimulationOutput(simulationData.FastSim, simulationData.ClockTickNumber, io_1[0], empty(), 0)];
    }, simIOs);
}

/**
 * As extractFastSimulationIOs but for FData - used by truth table logic.
 */
export function extractFastSimulationIOsFData(simIOs, simulationData) {
    return map((io) => {
        const io_1 = io;
        return [io_1, extractFastSimulationOutputFData(simulationData.FastSim, simulationData.ClockTickNumber, io_1[0], empty(), 0)];
    }, simIOs);
}

/**
 * Extract a component's label and its full name which includes all of its path to root of simulation.
 */
export function getFLabel(fs, fId_, fId__1) {
    const fc = FastSimulation__FastComponentOf_6546966D(fs, [fId_, fId__1]);
    return [fc.SimComponent.Label, fc.FullName];
}

/**
 * Extract the width of a component's output port.
 */
export function extractFastSimulationWidth(fs, fid_, fid__1, opn) {
    return item(opn, FastSimulation__FastComponentOf_6546966D(fs, [fid_, fid__1]).Outputs).Width | 0;
}

/**
 * Extract all Viewer components with names and wire widths.
 */
export function extractViewers(simulationData) {
    const fs = simulationData.FastSim;
    return map((fc_1) => {
        let tupledArg, tupledArg_1;
        const width = item(0, fc_1.Outputs).Width | 0;
        return [(tupledArg = fc_1.fId, getFLabel(fs, tupledArg[0], tupledArg[1])), width, (tupledArg_1 = fc_1.fId, extractFastSimulationOutput(fs, simulationData.ClockTickNumber, tupledArg_1[0], tupledArg_1[1], 0))];
    }, ofArray(simulationData.FastSim.FCompsByIndex.filter((fc) => {
        if (fc.FType.tag === 2) {
            return true;
        }
        else {
            return false;
        }
    })));
}

/**
 * As extractViewers but for FData - used by truth table logic.
 */
export function extractViewersFData(simulationData) {
    const fs = simulationData.FastSim;
    return map((fc_1) => {
        let tupledArg, tupledArg_1;
        const width = item(0, fc_1.Outputs).Width | 0;
        return [(tupledArg = fc_1.fId, getFLabel(fs, tupledArg[0], tupledArg[1])), width, (tupledArg_1 = fc_1.fId, extractFastSimulationOutputFData(fs, simulationData.ClockTickNumber, tupledArg_1[0], tupledArg_1[1], 0))];
    }, ofArray(fs.FCompsByIndex.filter((fc) => {
        if (fc.FType.tag === 2) {
            return true;
        }
        else {
            return false;
        }
    })));
}

/**
 * Check if the components and connections of a fast simulation and a canvas are the same.
 * Is the design the simulation was built from still what the project holds? False puts the
 * Refresh button up.
 * 
 * Asked of DesignAsDrawn and not of the SIMULATED sheets, because the two differ for a design
 * holding an array component: there the simulation is of a wrapper and a body, and the project has
 * neither - so every such simulation reported itself edited the moment it started.
 */
export function compareLoadedStates(fs, canv_, canv__1, p) {
    const canv = [canv_, canv__1];
    return forAll((ldc) => loadedComponentIsSameAsProject(canv[0], canv[1], ldc, p), fs.Design.DesignAsDrawn);
}

/**
 * Check if a fastComponent output is the same as the default value for all time steps.
 * Used by simulationView.
 * The current implementation seems not quite right when tick > MaxArraySize.
 * ToDo - make this work for all time steps
 */
export function outputsAreTheSameAsDefault(fs, fc, tick, currdefault) {
    const arr = getSubArray((item(0, fc.Outputs).Width > 32) ? IOArray__get_BigContents(item(0, fc.Outputs)) : map_1((x) => twosComp(item(0, fc.Outputs).Width, fromUInt32(x)), IOArray__get_U32Contents(item(0, fc.Outputs))), 0, (tick + 1) % fs.MaxArraySize);
    if (tick < 2) {
        return true;
    }
    else {
        return arr.every((elem) => equals(elem, currdefault));
    }
}

/**
 * Return array of simulation output values for a given output port.
 * Values are returned from steos 0 to (tick - 1).
 * Used by testParsser. Only works if tick < maxArraySize.
 */
export function getArrayOfOutputs(fc, outputNum, ticks) {
    return getSubArray((item(outputNum, fc.Outputs).UInt32Slab.length > 0) ? map_1(fromUInt32, IOArray__get_U32Contents(item(outputNum, fc.Outputs))) : IOArray__get_BigContents(item(0, fc.Outputs)), 0, ticks - 1);
}

